/**
 * Menu and page text that differs per edition (§ Edities › Frontend). Fase 1
 * has one section, Home, holding Departments and Users; both editions share
 * the same pages, only the wording differs (Fit: company/department/user —
 * Soccer: club/team/player, see § Wat Soccer nu inhoudt).
 */
export const editions = {
  fit: {
    sections: {
      home: 'Home',
      insights: 'Insights',
      programs: 'Programs',
      content: 'Content',
    },
    items: {
      overview: 'Overview',
      departments: 'Departments',
      users: 'Users',
      vitality: 'Vitality',
      participation: 'Participation',
      pilots: 'Pilots',
      challenges: 'Challenges',
      communications: 'Communication',
      documents: 'Documents',
      reports: 'Reports',
      settings: 'Settings',
    },
  },
  soccer: {
    sections: {
      home: 'Home',
      insights: 'Insights',
      programs: 'Programs',
    },
    items: {
      overview: 'Overview',
      departments: 'Teams',
      users: 'Players',
      vitality: 'Vitality',
      participation: 'Participation',
      pilots: 'Pilots',
      challenges: 'Challenges',
    },
  },
} as const;
